export default {
    Index: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Company: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    News: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Products: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Advantage: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Network: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Cooperation: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
    Joins: {
        title: "库课科技集团官网",
        meta: [{
            name: '库课科技集团官网',
            content: ""
        }]
    },
   
}